import { useEffect } from "react";
import i18n, { loadI18nResource } from "../i18n";

export function useDynamicI18n() {
  useEffect(() => {
    // Khi mount, và mỗi lần changeLanguage, load lại resource
    const handler = (lang) => loadI18nResource(lang);

    i18n.on("languageChanged", handler);

    // Lần đầu tiên cũng load luôn:
    loadI18nResource(i18n.language);

    return () => {
      i18n.off("languageChanged", handler);
    };
  }, []);
}
